import { render, staticRenderFns } from "./ResourceEventListDb.vue?vue&type=template&id=79576183"
import script from "./ResourceEventListDb.ts?vue&type=script&lang=ts&external"
export * from "./ResourceEventListDb.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports